import React from 'react';
import icons from '../../icons';
import urls from '../../urls';
import Banner from '../Banner/Banner';
import style from './Links.module.css';


const Links = () => {    
    return <>
        <Banner />
        <main className={ style.main }>
            <header>
                {/* <div className={ style.logo }><img alt="" src={ icons.logo_icon } /></div> */}
                <h2 className={ style.appHeader }>School<span>Diary</span></h2>
            </header>
            <section className={ style.item } style={{ marginTop: "5rem" }}>
                <a className={ style.link } href="https://play.google.com/store/apps/details?id=com.schooldiary.app" >
                    <div className={ style.logo }><img alt="" src={ icons.google_play_store_icon } /></div>
                    <h3>Google Play Store</h3>
                </a>
            </section>
            <section className={ style.item }>
                <h3 className={ style.link } onClick={ () => window.open(urls.base) } >
                    <div className={ style.logo }><img alt="" src={ icons.logo_icon } /></div>
                    <h3>Web</h3>
                </h3>
            </section>
            <section className={ style.item }>
                <a className={ style.link } href="https://www.instagram.com/schooldiary.app/" >
                    <div className={ style.logo }><img alt="" src={ icons.instagram_icon } /></div>
                    <h3>Instagram</h3>
                </a>
            </section>
        </main>
    </>
};

export default Links;
